import { doc, getDoc } from 'firebase/firestore'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { RiDeleteBin5Line } from 'react-icons/ri'
import { db } from '../../firebase'

const Row = ({ doc: row, index, setSelectedId }) => {
  const [employee, setEmployee] = useState({})
  const [color, setColor] = useState('')

  useEffect(() => {
    async function getEmployee() {
      const emSnap = await getDoc(doc(db, 'employees', row?.employeeId))
      if (emSnap.exists) {
        setEmployee(emSnap.data())
      }
    }
    getEmployee()

    function genColor() {
      const randomColor = Math.floor(Math.random() * 16777215).toString(16);
      setColor('#' + randomColor)
    }
    genColor()
  }, [row])

  const difdate = row?.endedAt !== '' && ((row?.endedAt.toDate().getTime() - row?.startedAt.toDate().getTime())) / 1000

  return (
    <tr className="bg-white border-b dark:bg-gray-50 dark:border-gray-200 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-100">
      <td className="flex items-center px-6 py-2 font-medium text-gray-900  whitespace-nowrap relative">
        <img className="w-10 h-10 rounded-full mr-2 object-cover" src={employee.imageUrl ? employee.imageUrl : 'https://www.seekpng.com/png/detail/428-4287240_no-avatar-user-circle-icon-png.png'} alt={employee.email} />   {employee.name}
      </td>
      <td className="px-6 py-2">
        {row.jobFilename}
      </td>
      <td className="px-6 py-2">
        {moment(row?.startedAt.toDate()).format('LLL')}
      </td>
      <td className="px-6 py-2">
        {row?.endedAt === '' ? '...' : moment(row?.endedAt.toDate()).format('LLL')}
      </td>
      <td className="px-6 py-2">
        {parseInt(difdate / 60 / 60) >= 10 ? parseInt(difdate / 60 / 60) : '0' + parseInt(difdate / 60 / 60)}<span className='font-semibold mx-[2px]'>:</span>
        {parseInt(difdate / 60 % 60) >= 10 ? parseInt(difdate / 60 % 60) : '0' + parseInt(difdate / 60 % 60)}<span className='font-semibold mx-[2px]'>:</span>
        {parseInt(difdate % 60) >= 10 ? parseInt(difdate % 60) : '0' + parseInt(difdate % 60)}
      </td>
      <td className="px-6 py-2">
        {row.round}
      </td>
      <td className="px-6 relative">
        <div className='flex items-center cursor-pointer p-2 w-11 active:bg-gray-300 justify-center rounded-full hover:bg-gray-200' onClick={() => setSelectedId(row.id)}>
          <RiDeleteBin5Line className='text-2xl cursor-pointer text-red-500' />
        </div>
        <span style={{ backgroundColor: color }} className='absolute top-1 right-0 shadow-md px-[6px] text-white border-2 border-slate-600 text-xs py-[1px] rounded-full'>{index}</span>
      </td>
    </tr>
  )
}

export default Row